import { Link } from 'react-router-dom';

import ThemeToggle from './ThemeToggle.jsx';
import './SiteHeader.css';

export default function SiteHeader() {
	return (
		<header className="site-header">
			<div className="site-header__inner app-container">
				<Link className="site-header__brand" to="/">
					<img
						className="site-header__logo"
						src="/static/img/logo.png"
						alt=""
						width="32"
						height="32"
					/>
					<span>Fantasy Nutmeg</span>
				</Link>
				<ThemeToggle />
			</div>
		</header>
	);
}
